/**
 * Component Registry for Avignon Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import { Footer } from './components/Footer';
import { TabbedCallouts } from './components/TabbedCallouts';
import { PinnedCallouts } from './components/PinnedCallouts';
import { PropertyOverview } from './components/PropertyOverview';
import { FloorplansList } from './components/FloorplansList';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { ApplyNowActions } from './components/ApplyNowActions';
import { PetPolicy } from './components/PetPolicy';
import { SitemapContent } from './components/SitemapContent';
import { ResidentAccess } from './components/ResidentAccess';
import { ThankYouContent } from './components/ThankYouContent';
import { ReviewsCallout } from './components/ReviewsCallout';
import { SisterProperties } from './components/SisterProperties';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Footer,
  TabbedCallouts,
  PinnedCallouts,
  PropertyOverview,
  FloorplansList,
  NeighborhoodMap,
  ApplyNowActions,
  PetPolicy,
  SitemapContent,
  ResidentAccess,
  ThankYouContent,
  ReviewsCallout,
  SisterProperties,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
